module.exports = __webpack_public_path__ + "img/ic_zhankai.05937211.svg";